// External-Dependencies
import { isUndefined, pickBy } from 'lodash';

// WP-Dependencies
import { Component } from '@wordpress/element';
import { PanelBody, QueryControls } from '@wordpress/components';
import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';
// import { __ } from '@wordpress/i18n';
// import { dateI18n, format, __experimentalGetSettings } from '@wordpress/date';
import { InspectorControls } from '@wordpress/block-editor';
import { withSelect } from '@wordpress/data';
import { decodeEntities } from '@wordpress/html-entities';

//Constants
import {
	MIN_EXCERPT_LENGTH,
	MAX_EXCERPT_LENGTH,
	MAX_POSTS_COLUMNS,
} from './constants';

//"GLOBALS"
const CATEGORIES_LIST_QUERY = {	per_page: -1 };
var activeCategory = {};


class LatestPostsEdit extends Component {

	constructor() {
		super( ...arguments );
		this.state = {
			categoriesList: [],
		};
	}

	componentDidMount() {
		this.isStillMounted = true;
		this.fetchRequest = apiFetch( {
			path: addQueryArgs( `/wp/v2/categories`, CATEGORIES_LIST_QUERY ),
		} )
			.then( ( categoriesList ) => {
				if ( this.isStillMounted ) {
					this.setState( { categoriesList } );
				}
			} )
			.catch( () => {
				if ( this.isStillMounted ) {
					this.setState( { categoriesList: [] } );
				}
			} );
	}

	componentWillUnmount() {
		this.isStillMounted = false;
	}

	render() {

		const {
			attributes,
			setAttributes,
			latestPosts,
		} = this.props;

		const { categoriesList } = this.state;

		const {
			displayPostContentRadio,
			displayPostContent,
			displayPostDate,
			postLayout,
			columns,
			order,
			orderBy,
			categories,
			postsToShow,
			excerptLength,
		} = attributes;

		const getActiveCategoryObj = () => {

			var result = categoriesList.filter(obj => {

			  return obj.id === Number(categories[0])
			})

			activeCategory = result[0];
		}

		const setCategory = (value) => {
			
			setAttributes( { categories: [value] } );
			getActiveCategoryObj();
		};

		const inspectorControls = (
			<InspectorControls>
				
				<PanelBody title="Kategorie auswählen">
					<QueryControls
						{ ...{ order, orderBy } }
						
						numberOfItems={ postsToShow }
						onNumberOfItemsChange={ ( value ) =>
							setAttributes( { postsToShow: value } )
						}

						onOrderChange={ ( value ) =>
							setAttributes( { order: value } )
						}
						onOrderByChange={ ( value ) =>
							setAttributes( { orderBy: value } )
						}

						categoriesList={ categoriesList }
						selectedCategoryId={ categories }
						onCategoryChange={ setCategory }
						
					/>
				</PanelBody>
			</InspectorControls>
			);

		getActiveCategoryObj();

		const displayName = activeCategory ? decodeEntities(activeCategory.name) : "Laden...";

		return (

			<React.Fragment>
				{inspectorControls}
				<p>
					<strong>GTÜ - Kategorie Slider:</strong><br/>
					{displayName}
				</p>
			</React.Fragment>
		);
	}
}

export default withSelect( ( select, props ) => {

	const {
		postsToShow,
		order,
		orderBy,
		categories,
	} = props.attributes;

	const { getEntityRecords } = select( 'core' );
	
	const { getSettings } = select( 'core/block-editor' );

	const catIds =
		categories && categories.length > 0
			? categories.map( ( cat ) => cat.id )
			: [];

	const latestPostsQuery = pickBy(
		{
			categories: catIds,
			order,
			orderby: orderBy,
			per_page: postsToShow,
		},
		( value ) => ! isUndefined( value )
	);

	const posts = getEntityRecords( 'postType', 'post', latestPostsQuery );

	return {
		latestPosts: ! Array.isArray( posts )
			? posts
			: posts.map( ( post ) => {

				return post;
			  } ),
	};

} )( LatestPostsEdit );





